<template>
  <form class="form" method="put">

    <HeaderApp />
    <div id="AppCollectionReedition" class="appFontBlack">
      <div class="AppCollectionMenu">
        <h2>Gestion de factures</h2>
        <div class="appCollectionReeditionEntete">
          <p>Factures sans date d'encaissement</p>
          <button @click.prevent="invoiceWithoutDate()" type="submit" class="appButtonModel2">Afficher</button>
        </div>
        <div class="appCollectionReeditionEntete">
          <p>Factures réalisées par date</p>
          <div class="appCollectionReeditionFlex">
            <div>
              <p>Du</p>
              <input type="date" id="date1" class="appInputStyle1" placeholder="01/01/2000">
            </div>
            <div>
              <p>Au</p>
              <input type="date" id="date2" class="appInputStyle1" placeholder="01/01/2000">
            </div>
          </div>
          <br>
          <button @click.prevent="invoiceWithDates()" type="submit" class="appButtonModel2">Afficher</button>
        </div>
        <div class="appCollectionReeditionEntete">
          <p>Visualiser une facture</p>
          <input type="text" v-model="search" class="appSearchBar" placeholder="Numéro de facture" id= "numberInvoiceToShow">
          <button @click.prevent="ShowMyinvoice()" type="submit" class="appButtonModel2">Visualiser la facture</button>
        </div>
      </div>
      <div id="appCollectionReeditionDatas"></div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import HeaderApp from '../Application/HeaderApp.vue'
import moment from 'moment'
import axios from 'axios'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'AppCollectionReedition',
  data () {
    return {
      invoice: ''
    }
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    ShowMyinvoice () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      const myInvoice = document.getElementById('numberInvoiceToShow')
      const numberInvoice = parseInt(myInvoice.value)
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
          var extractionOfInvoice = this.invoice.filter(function (listing) {
            return listing.number === numberInvoice
          })
          const myInvoice = extractionOfInvoice[0]._id
          axios.get(('https://privilegia.fr/api/factures/' + myInvoice), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
            .then((response) => {
              this.invoice = response.data
              this.$router.push('/App/Collection/Paiement/Facture?id=' + this.invoice._id)
            })
        })
    },
    invoiceWithoutDate () {
      // Effacer valeurs
      let listToRemove = document.getElementById('appCollectionReeditionDatas')
      if (listToRemove != null) {
        while (listToRemove.firstChild) {
          listToRemove.removeChild(listToRemove.firstChild)
        }
      }
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data.filter(invoice => invoice.categoryOfInvoice === 2 && invoice.dateBank === '-')
          this.invoice.sort((a, b) => (a.number < b.number ? 1 : -1))
          let myTotalCounter = this.invoice.length
          for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
            // Créer le HTML
            let newDiv = document.createElement('div')
            newDiv.className = 'appCollectionReeditionResultDiv'
            document.getElementById('appCollectionReeditionDatas').appendChild(newDiv)
            // Ligne 1
            let newDivLine1 = document.createElement('div')
            newDivLine1.className = 'appCollectionReeditionLine1'
            newDiv.appendChild(newDivLine1)
            let newDivLine1P1 = document.createElement('p')
            newDivLine1P1.innerText = '-'
            newDivLine1P1.innerText = this.format_date(this.invoice[myCounter].date)
            newDivLine1.appendChild(newDivLine1P1)
            let newDivLine1P2 = document.createElement('p')
            if (this.invoice[myCounter].number === 0) {
              newDivLine1P2.innerText = '-'
            } else {
              newDivLine1P2.innerText = this.invoice[myCounter].number
              newDivLine1P2.className = 'appHoverEffect'
            }
            newDivLine1P2.addEventListener('click', eventGoInvoice => {
              if (this.invoice[myCounter].number !== 0) {
                this.$router.push('/App/Collection/Paiement/Facture?id=' + this.invoice[myCounter]._id)
              }
            })
            newDivLine1.appendChild(newDivLine1P2)
            // Ligne 2
            let newDivLine2 = document.createElement('div')
            newDivLine2.className = 'appCollectionReeditionLine2'
            newDiv.appendChild(newDivLine2)
            let newDivLine2P1 = document.createElement('p')
            newDivLine2P1.innerText = this.invoice[myCounter].client + ' (' + this.invoice[myCounter].typeofpaiement + ')'
            newDivLine2.appendChild(newDivLine2P1)
            let newDivLine2P2 = document.createElement('p')
            newDivLine2P2.innerText = this.invoice[myCounter].totalprice.toFixed(2) + ' €'
            newDivLine2.appendChild(newDivLine2P2)
            // Ligne 3
            let newDivLine3 = document.createElement('div')
            newDivLine3.className = 'appCollectionReeditionLine3'
            newDiv.appendChild(newDivLine3)
            let newDivLine3P1 = document.createElement('p')
            if (this.invoice[myCounter].dateBank === '-') {
              newDivLine3P1.innerText = '-'
            } else {
              newDivLine3P1.innerText = this.format_date(this.invoice[myCounter].dateBank)
            }
            newDivLine3.appendChild(newDivLine3P1)
            let newDivLine3Input = document.createElement('input')
            newDivLine3Input.className = 'appInputStyle1'
            newDivLine3Input.id = 'inputID' + this.invoice[myCounter]._id
            newDivLine3Input.placeholder = '01/01/2000'
            newDivLine3Input.type = 'date'
            newDivLine3.appendChild(newDivLine3Input)
            let newDivLine3Button = document.createElement('button')
            newDivLine3Button.innerText = 'Corriger'
            newDivLine3Button.className = 'appButtonModel3'
            newDivLine3Button.id = 'buttonID' + this.invoice[myCounter]._id
            newDivLine3Button.addEventListener('click', eventChangeDate => {
              eventChangeDate.preventDefault()
              let idTomodify = this.invoice[myCounter]._id
              let newValue = document.getElementById('inputID' + this.invoice[myCounter]._id).value + 'T12:00:00'
              if (!newValue) {
                alert('date non renseignée')
              } else {
                axios
                  .put('https://privilegia.fr/api/factures/' + idTomodify,
                    {
                      'dateBank': newValue
                    }, { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
                  .then((response) => {
                    this.invoiceWithoutDate()
                  })
              }
            })
            newDivLine3.appendChild(newDivLine3Button)
          }
        })
    },
    invoiceWithDates () {
      // Effacer valeurs
      let listToRemove = document.getElementById('appCollectionReeditionDatas')
      if (listToRemove != null) {
        while (listToRemove.firstChild) {
          listToRemove.removeChild(listToRemove.firstChild)
        }
      }
      let date1 = document.getElementById('date1').value + 'T00:00:00'
      let date2 = document.getElementById('date2').value + 'T23:59:00'
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data.filter(invoice => invoice.categoryOfInvoice === 2 && invoice.date >= date1 && invoice.date <= date2)
          let myTotalCounter = this.invoice.length
          for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
            // Créer le HTML
            let newDiv = document.createElement('div')
            newDiv.className = 'appCollectionReeditionResultDiv'
            document.getElementById('appCollectionReeditionDatas').appendChild(newDiv)
            // Ligne 1
            let newDivLine1 = document.createElement('div')
            newDivLine1.className = 'appCollectionReeditionLine1'
            newDiv.appendChild(newDivLine1)
            let newDivLine1P1 = document.createElement('p')
            newDivLine1P1.innerText = '-'
            newDivLine1P1.innerText = this.format_date(this.invoice[myCounter].date)
            newDivLine1.appendChild(newDivLine1P1)
            let newDivLine1P2 = document.createElement('p')
            if (this.invoice[myCounter].number === 0) {
              newDivLine1P2.innerText = '-'
            } else {
              newDivLine1P2.innerText = this.invoice[myCounter].number
              newDivLine1P2.className = 'appHoverEffect'
            }
            newDivLine1P2.addEventListener('click', eventGoInvoice => {
              if (this.invoice[myCounter].number !== 0) {
                this.$router.push('/App/Collection/Paiement/Facture?id=' + this.invoice[myCounter]._id)
              }
            })
            newDivLine1.appendChild(newDivLine1P2)
            // Ligne 2
            let newDivLine2 = document.createElement('div')
            newDivLine2.className = 'appCollectionReeditionLine2'
            newDiv.appendChild(newDivLine2)
            let newDivLine2P1 = document.createElement('p')
            newDivLine2P1.innerText = this.invoice[myCounter].client
            newDivLine2.appendChild(newDivLine2P1)
            let newDivLine2P2 = document.createElement('p')
            newDivLine2P2.innerText = this.invoice[myCounter].totalprice.toFixed(2) + ' €'
            newDivLine2.appendChild(newDivLine2P2)
            // Ligne 3
            let newDivLine3 = document.createElement('div')
            newDivLine3.className = 'appCollectionReeditionLine3'
            newDiv.appendChild(newDivLine3)
            let newDivLine3P1 = document.createElement('p')
            if (this.invoice[myCounter].dateBank === '-') {
              newDivLine3P1.innerText = '-'
            } else {
              newDivLine3P1.innerText = this.format_date(this.invoice[myCounter].dateBank)
            }
            newDivLine3.appendChild(newDivLine3P1)
            let newDivLine3Input = document.createElement('input')
            newDivLine3Input.className = 'appInputStyle1'
            newDivLine3Input.id = 'inputID' + this.invoice[myCounter]._id
            newDivLine3Input.placeholder = '01/01/2000'
            newDivLine3Input.type = 'date'
            newDivLine3.appendChild(newDivLine3Input)
            let newDivLine3Button = document.createElement('button')
            newDivLine3Button.innerText = 'Corriger'
            newDivLine3Button.className = 'appButtonModel3'
            newDivLine3Button.id = 'buttonID' + this.invoice[myCounter]._id
            newDivLine3Button.addEventListener('click', eventChangeDate => {
              eventChangeDate.preventDefault()
              let idTomodify = this.invoice[myCounter]._id
              let newValue = document.getElementById('inputID' + this.invoice[myCounter]._id).value + 'T12:00:00'
              if (!newValue) {
                alert('date non renseignée')
              } else {
                axios
                  .put('https://privilegia.fr/api/factures/' + idTomodify,
                    {
                      'dateBank': newValue
                    }, { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
                  .then((response) => {
                    this.invoiceWithDates()
                  })
              }
            })
            newDivLine3.appendChild(newDivLine3Button)
          }
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Application/AppCollectionReedition.vue